module.exports = "/images/mi-sisa-go@2x.png?5af20e176150424a66e55991e054b2df";